import { UrlSearchParamsSchema } from "@/features/discovery";
import { EDGE_COLORS } from "@wags/ui/edge-color.ts";
import { seoMeta } from "@/lib/ui/seo";

export const filterQuizRoute = {
    validateSearch: UrlSearchParamsSchema,
    head: () => {
        const seo = seoMeta({
            title: "Filter Quiz — Wags",
            description:
                "Answer a few questions to find dogs that fit your lifestyle.",
            url: "/filter-quiz",
        });
        return {
            ...seo,
            meta: [
                ...seo.meta,
                {
                    name: "theme-color",
                    content: EDGE_COLORS.dobermanBlack,
                },
                {
                    name: "color-scheme",
                    content: "dark",
                },
            ],
        };
    },
};
